export enum TableColumnType  {
  Text = 'TEXT',
  Date = 'DATE',
  Number = 'NUMBER',
}